module.exports = __webpack_public_path__ + "static/media/analytics.d59c4c7a.svg";